import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateform'
})
export class DateformPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value[6]+value[7]+"/"+value[4]+value[5]+"/"+value[0]+value[1]+value[2]+value[3];
    
  }

}
